(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dreibach-cart-addons"] && !Shopify.designMode) return;
  try {
    class DbCartAddons extends HTMLElement {
  connectedCallback() {
    this.controller=new AbortController();
    this.addEventListener('submit',event=>this.add(event),{signal:this.controller.signal});
    this.addEventListener('change',event=>{
      const select=event.target.closest('select');
      if(select) select.closest('form').querySelector('[data-addon-price]').textContent=select.selectedOptions[0].dataset.price;
    },{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller.abort();}
  async add(event){
    event.preventDefault();
    if(this.busy)return;
    const form=event.target;
    if(!(form instanceof HTMLFormElement))return;
    this.busy=true;
    const buttons=[...this.querySelectorAll('button')];
    const button=form.querySelector('button');
    const original=button.textContent;
    buttons.forEach(b=>b.disabled=true);
    button.textContent=this.dataset.adding;
    this.querySelector('.db-addon-error').textContent='';
    try{
      const { CartAddEvent } = await import('@theme/events');
      const sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(e=>e.dataset.sectionId))].slice(0,5);
      const payload={items:[{id:form.elements.id.value,quantity:1}],sections,sections_url:window.location.pathname};
      const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      const result=await response.json();
      if(!response.ok||result.status)throw new Error(result.description||this.dataset.error);
      this.dispatchEvent(new CartAddEvent({},'db-cart-addons',{source:'db-cart-addons',productId:form.dataset.productId,itemCount:1,sections:result.sections}));
    }catch(error){this.querySelector('.db-addon-error').textContent=error.message||this.dataset.error;}
    finally{this.busy=false;buttons.forEach(b=>b.disabled=false);button.textContent=original;}
  }
}
if(!customElements.get('db-cart-addons'))customElements.define('db-cart-addons',DbCartAddons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dreibach-delivery"] && !Shopify.designMode) return;
  try {
    function dbDeliveryWindow(now, cutoff, minimum, maximum, holidays) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now).map(p => [p.type,p.value]));
  const today = new Date(Date.UTC(Number(parts.year), Number(parts.month)-1, Number(parts.day)));
  const key = d => d.toISOString().slice(0,10);
  const working = d => d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !holidays.has(key(d));
  const advance = d => new Date(d.getTime()+86400000);
  const before = Number(parts.hour) < cutoff;
  let dispatch = new Date(today);
  const sameDay = working(today) && before;
  if (!sameDay) { dispatch = advance(dispatch); while (!working(dispatch)) dispatch = advance(dispatch); }
  const addWorkingDays = days => { let d = new Date(dispatch); for (let i=0;i<days;) { d=advance(d); if (working(d)) i++; } return d; };
  return { sameDay, dispatch, start: addWorkingDays(minimum), end: addWorkingDays(Math.max(minimum,maximum)), minutes: Math.max(0,cutoff*60-Number(parts.hour)*60-Number(parts.minute)) };
}
class DbDelivery extends HTMLElement {
  connectedCallback() {
    this.schedule=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());};
    this.observer=new MutationObserver(this.schedule);
    this.observer.observe(this,{childList:true,subtree:true});
    this.schedule();
    this.timer=setInterval(()=>this.update(),60000);
  }
  disconnectedCallback() { clearInterval(this.timer);cancelAnimationFrame(this.frame);this.observer.disconnect(); }
  update() {
    const dispatchNode=this.querySelector('[data-dispatch]');
    const arrivalNode=this.querySelector('[data-arrival]');
    if(!dispatchNode||!arrivalNode)return;
    const x=dbDeliveryWindow(new Date(),Number(this.dataset.cutoff)||14,Number(this.dataset.min)||1,Number(this.dataset.max)||3,new Set(this.dataset.holidays.split(',').map(s=>s.trim())));
    const format=d=>new Intl.DateTimeFormat('en-GB',{weekday:'short',day:'numeric',month:'short',timeZone:'UTC'}).format(d);
    const time=`${Math.floor(x.minutes/60)}${this.dataset.hour} ${x.minutes%60}${this.dataset.minute}`;
    const dispatchText=x.sameDay?this.dataset.today.replace('[time]',time):this.dataset.next.replace('[date]',format(x.dispatch));
    const arrivalText=this.dataset.arrival.replace('[start]',format(x.start)).replace('[end]',format(x.end));
    if(dispatchNode.textContent!==dispatchText)dispatchNode.textContent=dispatchText;
    if(arrivalNode.textContent!==arrivalText)arrivalNode.textContent=arrivalText;
  }
}
if (!customElements.get('db-delivery')) customElements.define('db-delivery',DbDelivery);
const refreshDbDelivery=()=>document.querySelectorAll('db-delivery').forEach(element=>DbDelivery.prototype.update.call(element));
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshDbDelivery,{once:true});
else refreshDbDelivery();
document.addEventListener('cart:update',()=>requestAnimationFrame(refreshDbDelivery));
document.addEventListener('toggle',event=>{if(event.target instanceof HTMLDialogElement)refreshDbDelivery();},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dreibach-sticky-buy"] && !Shopify.designMode) return;
  try {
    class DbStickyBuy extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();
    this.root=this.closest('.shopify-section');
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>this.start(),{once:true,signal:this.controller.signal});
    else this.start();
  }
  start(){
    if(!this.isConnected)return;
    this.sync();
    const refresh=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=null;this.updateVisibility();});};
    window.addEventListener('scroll',refresh,{passive:true,signal:this.controller.signal});
    window.addEventListener('resize',refresh,{signal:this.controller.signal});
    document.addEventListener('variant:update',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.sync(),100);},{signal:this.controller.signal});
    this.querySelector('button').addEventListener('click',()=>{const source=this.root.querySelector('.product-information .add-to-cart-button');if(source&&!source.disabled)source.click();},{signal:this.controller.signal});
  }
  sync(){
    const source=this.root.querySelector('.product-information .add-to-cart-button');
    if(!source)return;
    const button=this.querySelector('button');button.disabled=source.disabled;
    button.textContent=source.querySelector('.add-to-cart-text__content')?.textContent?.trim()||source.querySelector('.add-to-cart-text')?.textContent?.trim()||source.textContent.trim();
    const price=this.root.querySelector('.product-details product-price .price');
    if(price)this.querySelector('[data-sticky-price]').textContent=price.textContent;
    this.querySelector('[data-sticky-options]').textContent=[...this.root.querySelectorAll('.product-details variant-picker input:checked,.product-details variant-picker select option:checked')].map(e=>e.value).join(' / ');
    this.updateVisibility();
  }
  updateVisibility(){const source=this.root.querySelector('.product-information .add-to-cart-button');this.hidden=!source||source.getBoundingClientRect().bottom>=0;}
  disconnectedCallback(){this.controller.abort();cancelAnimationFrame(this.frame);clearTimeout(this.timer);}
}
if(!customElements.get('db-sticky-buy'))customElements.define('db-sticky-buy',DbStickyBuy);
  } catch(e) { console.error(e); }
})();

})();
